// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3vvN6","boxTitle":"Qualiphy_boxTitle__8rDY7","box":"Qualiphy_box__28GIh","toggleWrap":"Qualiphy_toggleWrap__2CqAY"};